import { IReward } from "api/types";
import Button from "components/common/Button/Button";
import Text from "components/common/Text/Text";
import Widget from "components/common/Widget";
import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

interface IRewardsListReward {
  id?: string;
  className?: string;
  reward: IReward;
  pointsBalance?: number;
  tenantId?: string;
  locationId?: string;
  imageBaseUrl?: string;
  addToCart?(reward: IReward): void;
}

const Reward = styled(
  ({
    className,
    reward,
    addToCart,
    pointsBalance = 0,
    tenantId,
    locationId,
    imageBaseUrl
  }: IRewardsListReward) => {
    const onClick = () => (addToCart ? addToCart(reward) : null);
    const { id, name, defaultImage, pointsRequired, imageId }: any = reward;
    const disabled = pointsRequired > pointsBalance;
    return (
      <Widget className={`${className} ${disabled ? `disabled` : ``}`}>
        <Image src={imageId !== "" ? `${imageId}` : defaultImage} />
        <Name>{name}</Name>
        <Points>{pointsRequired} Points</Points>
        <Button id={`add-reward-${id}`} primary onClick={onClick}>
          Add
        </Button>
      </Widget>
    );
  }
)`
  background: ${theme.color.secondary};
  margin-bottom: 2rem;
  ${Button} {
    display: block;
    margin: 0 auto;
  }

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
`;

const Name = styled(Text)`
  text-align: center;
  display: block;
  width: 100%;
  font-size: 16px;
  margin-top: 15px;
`;

const Points = styled(Text)`
  text-align: center;
  display: block;
  width: 100%;
  margin-top: 35px;
  font-size: 14px;
  margin-bottom: 15px;
`;

const Image = styled.img`
  text-align: center;
  max-height: 65px;
  max-width: 100%;
  margin-left: auto;
  display: block;
  margin-right: auto;
`;

export default Reward;



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/ChooseRewards/RewardsList/Reward.tsx